import React, { useEffect } from 'react';
import { STORAGE_KEYS } from 'utils/constants';
import { FileUploader } from '@cokitchen/cokitchen-components';
import useNewShopContext from 'contexts/create-shop.context';

const CreateShopImages = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const { createShopForm, setCreateShopForm, setDisabled } = useNewShopContext();

  useEffect(() => {
    const { images = [], logo = '' } = createShopForm;
    setDisabled(images?.length === 0 || !logo);
  }, [createShopForm]);

  return (
    <div>
      <div className='mb-8'>
        <FileUploader
          token={token}
          fileUrls={createShopForm?.images}
          label={<h3 className='font-medium mb-2'>Add shop image </h3>}
          setFileUrls={(k) => setCreateShopForm({ ...createShopForm, images: k })}
        />
      </div>
      <div>
        <FileUploader
          token={token}
          fileUrls={createShopForm.logo ? [createShopForm.logo] : []}
          label={<h3 className='font-medium mb-2'>Add shop logo </h3>}
          setFileUrls={(k) => setCreateShopForm({ ...createShopForm, logo: k[0] })}
        />
      </div>
    </div>
  );
};

export default CreateShopImages;
